export default __webpack_public_path__ + "static/lavinia-939523ec5fac677888c48f2d5e14091d.jpg";